import axios from 'axios';

import { HttpRoutes } from 'utils/constant';

import { getStateName } from '../utils';
import { gtmEventForFieldSelect } from '../utils/analyticsGTM';

import { logProfileUpdateActivity } from './logActivity';
import { updateUserNotifications,updateUserProfile } from './userService';

const remoteValues = [
  'Work From Home',
  'Remote (Work From Home)',
  'Telecommute (Work From Home)',
  'Virtual (Work From Home)',
];

const updateProfile = (data, field) => {
  const newFieldValue = data[field] || data.nextValue;
  const previousFieldValue = data.prevValue;

  delete data.prevValue;

  if (data.nextValue !== undefined) delete data.nextValue;

  return updateUserProfile(data)
    .then((response) => {
      if (
        data?.extendedLocations &&
        data?.extendedLocations?.length &&
        previousFieldValue?.extendedLocations &&
        previousFieldValue?.extendedLocations?.length
      ) {
        gtmEventForFieldSelect('extendedLocations');
        logProfileUpdateActivity(
          'extendedLocations',
          previousFieldValue?.extendedLocations,
          data?.extendedLocations
        );
      }
      gtmEventForFieldSelect(field);
      logProfileUpdateActivity(field, previousFieldValue, newFieldValue);

      return response;
    })
    .catch((err) => {
      return err;
    });
};

export const updateMajor = (data) => {
  return updateProfile(data, 'major');
};

export const updateEducation = (data) => {
  return updateProfile(data, 'educationLevel');
};

export const updateJobLevels = (data) => {
  return updateProfile(data, 'jobLevels');
};

export const updateJobTitles = (data) => {
  if (data.titles && data.titles.length) {
    data.titles = data.titles.map((title) => ({
      originalSearch: title.originalSearch,
      normalizedTitle: title.normalizedTitle || '',
    }));
  }
  return updateProfile(data, 'titles');
};

export const updateLocation = (data) => {
  let validLocations = [];
  let extendedLocations = [];
  data.location = data.location || [];
  data.location.map((item) => {
    if (remoteValues.includes(item)) {
      extendedLocations = ['Work From Home'];
    } else {
      if (!item.city && item.state && item.state.length < 3) {
        item.city = '';
        item.state = getStateName(item.state);
      }
      validLocations.push(item);
    }
  });
  data.location = validLocations;
  if (extendedLocations.length) {
    data.extendedLocations = extendedLocations;
  } else {
    data.extendedLocations = [];
  }

  return updateProfile(data, 'location');
};

export const updateCompanies = (data) => {
  return updateProfile(data, 'surveySelectedCompanies');
};

export const updateJobType = (data) => {
  return updateProfile(data, 'jobType');
};

export const updateSalary = (data) => {
  return updateProfile(data, 'minYearlySalaryDesired');
};

export const updateGoal = (data) => {
  return updateProfile(data, 'goal');
};

export const updateStress = (data) => {
  return updateProfile(data, 'stress');
};

export const updateSitting = (data) => {
  return updateProfile(data, 'sitting');
};

export const updateRepetition = (data) => {
  return updateProfile(data, 'repetition');
};

export const updateCompanyType = (data) => {
  return updateProfile(data, 'companyType');
};

export const updateImportant = (data) => {
  return updateProfile(data, 'importantFeatures');
};

export const updateDistance = (data) => {
  return updateProfile(data, 'radiusCategory');
};

export const updateUserInfo = (data, field) => {
  return updateProfile(data, field);
};

export const updateEmailNotification = (data) => {
  return updateProfile(data, 'sendEmailNotification');
};

export const updateNotifications = (data) => updateUserNotifications(data);

export const updateRightToWork = (data) => {
  data.rightToWork = data.rightToWork ? 'yes' : 'no';
  return updateProfile(data, 'rightToWork');
};

export const updateRelocation = (data) => {
  data.relocation = data.relocation ? 'yes' : 'no';
  return updateProfile(data, 'relocation');
};

export const filterEnabledFilterData = (filterData, single) => {
  if (single) {
    return filterData.find((item) => item.enabled);
  }
  return filterData.filter((item) => item.enabled);
};

export const getFilterText = (filterData, single) => {
  const filteredData = filterEnabledFilterData(filterData);
  if (single) {
    const singleItem = filteredData.find((item) => item.enabled);
    return singleItem ? singleItem.displayName : '';
  }
  return filteredData.map((item) => item.displayName).join(', ');
};

const setupEnabledData = (arr, enabled, prop) => {
  return arr.map(function (obj) {
    if (enabled.indexOf(prop ? obj[prop] : obj.value) >= 0) {
      obj.enabled = true;
    }
    return obj;
  });
};

export const setupEducationFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'None', value: 'none' },
      { displayName: 'High School', value: 'highschool' },
      { displayName: 'Associate', value: 'associate' },
      { displayName: "Bachelor's", value: 'bachelors' },
      { displayName: "Master's", value: 'masters' },
      { displayName: 'Doctorate', value: 'doctorate' },
    ],
    enabled
  );
};

export const setupJobLevelsFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Entry Level', value: 'entry-level' },
      { displayName: 'Junior Level', value: 'junior-level' },
      { displayName: 'Mid Level', value: 'mid-level' },
      { displayName: 'Senior Level', value: 'senior-level' },
      { displayName: 'Management', value: 'management' },
      { displayName: 'Executive', value: 'executive' },
    ],
    enabled
  );
};

export const setupJobTypesFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Full Time', value: 'full-time' },
      { displayName: 'Part Time', value: 'part-time' },
      { displayName: 'Internship', value: 'internship' },
      { displayName: 'Temporary', value: 'temporary' },
    ],
    enabled
  );
};

export const setupGoalFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Getting the best pay', value: 'highest-paying' },
      { displayName: 'Working in a great environment', value: 'best-place-to-work' },
      { displayName: 'Job stability', value: 'stable' },
      { displayName: 'Starting as soon as possible', value: 'job-start-now' },
      { displayName: 'Growing and learning', value: 'opportunities-to-grow' },
    ],
    enabled
  );
};

export const setupMindFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Mind', value: 'mind' },
      { displayName: "Don't Mind", value: 'dont-mind' },
    ],
    enabled
  );
};

export const setupSittingFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Mind', value: 'walk-around' },
      { displayName: "Don't Mind", value: 'mostly-sitting' },
    ],
    enabled
  );
};

export const setupCompanyTypeFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'A small or medium company', value: 'small-company' },
      { displayName: 'A big company', value: 'big-company' },
      { displayName: 'A non-profit organization', value: 'non-profit-organization' },
      { displayName: 'Any/All', value: 'any-all' },
    ],
    enabled
  );
};

export const setupDistanceFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: '0 Miles', value: '0m' },
      { displayName: '10 Miles', value: '10m' },
      { displayName: '25 Miles', value: '25m' },
      { displayName: '50 Miles', value: '50m' },
      { displayName: '75 Miles', value: '75m' },
    ],
    enabled
  );
};

export const setupLocationFilterData = (profileLocationArray) => {
  if (!profileLocationArray[0]) {
    return [];
  }
  var filterLocation = [],
    hasWorkFromHome = false;
  profileLocationArray.forEach(function (location) {
    if (remoteValues.includes(location)) {
      if (!hasWorkFromHome) {
        hasWorkFromHome = true;
        filterLocation.push({
          displayName: location,
          value: location,
          enabled: true,
        });
      }
    } else {
      filterLocation.push({
        displayName: location.city ? location.city + ', ' + location.state : location.state,
        value: {
          city: location.city,
          state: location.state,
        },
        enabled: true,
      });
    }
  });
  return filterLocation;
};

export const setupImportantFilterData = (enabled) => {
  return setupEnabledData(
    [
      { displayName: 'Healthcare benefits', value: 'employee-benefits' },
      { displayName: 'Retirement plans', value: 'retirement-plan' },
      { displayName: 'Work-life balance', value: 'work-life-balance' },
      { displayName: 'Gym membership', value: 'gym' },
      { displayName: 'Free meals', value: 'free-meals' },
    ],
    enabled
  );
};

export const uploadImage = async (payload) => {
    const formData = new FormData();

    formData.append('file', payload);

    try {
      const response = await axios.post(HttpRoutes.userImageUpload, formData);
      const data = response.data.path || '';
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
}
